import { useCurrencySignalREvents } from '@gat-ship/signalr'
import { currencyRefDataSource } from '../state/currency-datasource'

// Currency-specific SignalR subscription, lazily created once and shared. The
// event names/payloads are domain-specific, so the wiring stays here rather
// than in the generic factory; the handlers drive the shared cache through the
// datasource's `fetch` / `remove`.
let signalR: ReturnType<typeof useCurrencySignalREvents> | null = null
function getSignalR() {
  if (!signalR) {
    signalR = useCurrencySignalREvents({
      onCurrencyAdded: () => {
        currencyRefDataSource.fetch(true)
      },
      onCurrencyRemoved: (payload) => {
        currencyRefDataSource.remove(payload.message.code)
      }
    })
  }
  return signalR
}

/**
 * Shared currency reference data for select/combobox pickers. All callers share
 * one module-level cache plus a SignalR subscription that keeps it in sync (see
 * `state/currency-datasource.ts`).
 */
export function useSelectCurrencyDataSource() {
  return {
    currencies: currencyRefDataSource.items,
    loadingCurrencies: currencyRefDataSource.loading,
    fetchCurrencies: currencyRefDataSource.fetch,
    getCurrency: currencyRefDataSource.get,
    clearData() {
      currencyRefDataSource.clear()
      if (signalR) {
        signalR.unsubscribeFromCurrencyEvents()
        signalR = null
      }
    },
    signalR: getSignalR()
  }
}
